const TechnicalLV15 = () => {
    return (
        <div>
            <p><span style={ { fontSize: "24px" } }><strong>1. Sekojiet spiedienam riepās</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tas ir ļoti svarīgi pareizai riepu ekspluatācijai. Svarīgi zināt, ka pārāk zems vai, otrādi, pārāk augsts spiediens riepās izraisa nevienmērīgu riepas nodilumu un riepas pārkaršanu, kas savukārt var novest pie neatgriezeniskām izmaiņām riepas struktūrā un vēlāk arī pie tās bojājuma.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Spiediena pārbaude ir jāveic "aukstai" riepai, jo ekspluatācijas laikā, riepai uzkarstot, spiediens tajā paaugstinās. Iekšējam spiedienam, kas mērīts "aukstā" riepā, jāatbilst spiedienam, ko nosaka automašīnas ražotājs vai riepu ražotājs.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tas ir norādīts automašīnas ekspluatācijas instrukcijā, kā arī bieži tiek dublēts uz degvielas tvertnes vāciņa iekšpuses vai uz virsbūves statnes pie vadītāja durvīm.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Uzmanību! Neregulējiet riepas spiedienu "karstai" riepai. Spiediena regulēšanu drīkst veikt tikai "aukstai" riepai.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>2. Sekojiet riepas ārējam stāvoklim</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Uz ventiļa vienmēr ir jābūt uzgalim, kas pasargā ventiļa serdi no netīrumiem un putekļiem. Ir jāseko, lai uz riepas protektora un riepas borta nebūtu dziļu iegriezumu, plaisu, burbuļu, izlīdušu diegu vai redzamu korda konstrukcijas stiegru.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tāpat ir jāseko, lai uz riepas protektora nebūtu svešķermeņu, piemēram, naglu, asu metāla daļiņu u.tml., kuru izkrišana no riepas var novest pie strauja spiediena krituma riepā un līdz ar to arī pie pēkšņas automašīnas vadāmības pasliktināšanās.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>3. Sekojiet riepas nodilumam</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepām ar lielu nodiluma pakāpi ir lielāka iespēja tikt bojātām. Būtiski palielinās arī akvaplanēšanas risks, jo riepas protektora rievas, kas paredzētas ūdens novadīšanai, nodiluma rezultātā kļūst seklākas.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>4. Paaugstināta riepas nodiluma pamatfaktori</strong></span></p>

            <p>&nbsp;</p>

            <ul>
                <li>Ceļa seguma kvalitāte: daži ceļa segumi, īpaši asfalta segumi ar maziem un asiem akmentiņiem, var ievērojami palielināt riepas nodilumu.</li>
                <li>Vadīšanas stils un ātrums: straujš paātrinājums, bieža un intensīva bremzēšana, kā arī strauja manevrēšana pie lieliem ātrumiem var būtiski samazināt riepas kalpošanas ilgumu.</li>
                <li>Āra temperatūra: riepas noturība pret dilšanu lielā mērā ir atkarīga arī no gaisa un ceļa seguma temperatūras braukšanas laikā.</li>
                <li>Pārslodze: pie riepas pārslodzes tās kalpošanas ilgums ievērojami samazinās.</li>
                <li>Nepareizs spiediens riepās: ja riepas spiediens ir mazāks vai lielāks par ieteicamo, riepas kalpošanas ilgums samazinās.</li>
            </ul>
        </div>
    );
};

export default TechnicalLV15;


